import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { WAY_BILL_MODULE } from '../../configs/moduleNames';
import { BEGIN, FAILED, SUCCESSFUL } from '../../configs/actionNames';

export const LOAD_WAY_BILL_BY_ID = '_LOAD_WAY_BILL_BY_ID';
export const LOAD_WAY_BILL = '_LOAD_WAY_BILL';

export const loadWayBillById = createDeferredAction(WAY_BILL_MODULE + LOAD_WAY_BILL_BY_ID);
export const loadWayBillByIdSuccessful = createAction(WAY_BILL_MODULE + LOAD_WAY_BILL_BY_ID + SUCCESSFUL);
export const loadWayBillByIdFailed = createAction(WAY_BILL_MODULE + LOAD_WAY_BILL_BY_ID + FAILED);

export const loadWayBill = createDeferredAction(WAY_BILL_MODULE + LOAD_WAY_BILL);
export const loadWayBillBegin = createAction(WAY_BILL_MODULE + LOAD_WAY_BILL + BEGIN);
export const loadWayBillSuccessful = createAction(WAY_BILL_MODULE + LOAD_WAY_BILL + SUCCESSFUL);
export const loadWayBillFailed = createAction(WAY_BILL_MODULE + LOAD_WAY_BILL + FAILED);
